import { useId } from "react";
import styles from "./instanceDetail.module.css";

// Caveats and definitions live behind a "?" marker instead of as paragraphs,
// so the numbers stay the first thing a reader sees. Shown on hover and focus.
export const Hint = ({ text }: { readonly text: string }): JSX.Element => {
  const id = useId();
  return (
    <span className={styles.hintWrap}>
      <button type="button" className={styles.hint} aria-describedby={id} aria-label="More info">
        ?
      </button>
      <span role="tooltip" id={id} className={styles.hintTip}>
        {text}
      </span>
    </span>
  );
};
